import StickyNote2Icon from "@mui/icons-material/StickyNote2";
import { IconButton, Tooltip } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

interface DecisionLogButtonProps {
  onClick: () => void;
  disabled: boolean;
}

export const DecisionLogButton: React.FC<DecisionLogButtonProps> = ({
  onClick,
  disabled,
}) => {
  const { t } = useTranslation();

  const button = (
    <IconButton
      color="primary"
      onClick={onClick}
      disabled={disabled}
      size="medium"
    >
      <StickyNote2Icon />
    </IconButton>
  );

  return (
    <Tooltip title={disabled ? t('screens.ramp.autoPark.decisionLogButton.disabledTooltip') : t('screens.ramp.autoPark.decisionLogButton.tooltip')}>
      <span>{button}</span>
    </Tooltip>
  );
};
